
import { Component, Prop, Vue } from "vue-property-decorator";
import { copyToClipboard } from "@/utils/clipboard-utils";

@Component
export default class CopyToClipboard extends Vue {
  @Prop({ type: String, required: true }) public value!: string;
  @Prop({ type: String, required: true }) public iconId!: string;
  @Prop({ type: String, default: "" }) public dataCy!: string;

  public showTooltip: boolean = false;

  public async handleCopy() : Promise<void> {
    await copyToClipboard(this.value);
    
    this.showTooltip = true;
    setTimeout(() => { this.showTooltip = false; }, 2000);
  }
}
